import { INFOBULLE_HOMONYME, marqueHomonyme } from '../lib/homonyme'

/**
 * Astérisque après le nom d'un dossier homonyme, avec info-bulle.
 *
 * Purement visuel et dérivé de `homonyme` : ne remplace ni ne modifie le nom.
 * L'info-bulle passe aussi par `title` (souris) et par un texte réservé aux
 * lecteurs d'écran (l'astérisque seul ne dit rien).
 */
export function MarqueHomonyme({ homonyme }: { homonyme: boolean }) {
  const marque = marqueHomonyme(homonyme)
  if (marque === null) return null

  return (
    <span data-test="marque-homonyme" title={INFOBULLE_HOMONYME} className="ml-0.5 cursor-help font-bold">
      <span aria-hidden="true">{marque}</span>
      <span className="sr-only">{INFOBULLE_HOMONYME}</span>
    </span>
  )
}
